import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
} from '@components/text-editors/addons/field-mapping';

import { EmailListField } from './email-list-field';

export type EmailFieldProps = Omit<BaseFieldMappingFieldProps, keyof FieldMappingData> & {
  single?: boolean;
  hasResetError?: boolean;
} & FieldMappingData;

export const EmailField = ({ defaultValue, onChange, ...rest }: EmailFieldProps) => {
  return (
    <EmailListField
      single
      defaultValue={defaultValue ? [defaultValue] : undefined}
      onChange={(value) => onChange?.(value[0])}
      {...rest}
    />
  );
};
